;(function () {
  angular
    .module('contrast.org.vulnerabilities')
    .controller('OrgVulnOverviewCtrl', OrgVulnOverviewCtrl)

  function OrgVulnOverviewCtrl(
    _,
    $scope,
    $rootScope,
    $routeParams,
    $location,
    $interval,
    $uibModal,
    $q,
    $translate,
    logger,
    dialogs,
    permissions,
    currentTraceService,
    TagFactory,
    ApplicationFactory,
    BugtrackerFactory,
    GlobalFactory,
    appTracesApiConfig,
    orgTraceApiConfig,
    serverVulnsApiConfig,
    ErrorService,
    UserService,
    traceCommonRenderService,
    VulnerabilitiesService,
    APP_IMPORTANCE_RANKING,
    EXPORT_TYPES,
    VULN_STATUS,
    csSendVulnService,
    HistoryService,
    VULNERABILITY_TYPE,
    ORG_VULN_EVENTS,
    VULN_DISCUSSION_EVENTS,
    VULN_REQUEST_EVENTS
  ) {
    'ngInject'

    var translGlobal = {
      title_overview: $translate.instant('title_overview'),
      title_howToFix: $translate.instant('title_howToFix'),
      title_httpInfo: $translate.instant('title_httpInfo'),
      title_details: $translate.instant('title_details'),
      title_notes_extraInfo: $translate.instant('title_notes_extraInfo'),
      title_activity: $translate.instant('title_activity')
    }

    var traceUuid = $routeParams.uuid,
      _deregisterCurrentTraceOnChange

    angular.extend($scope, {
      isSticky: true,
      isOrgVulnPage: true,
      active: '',
      routes: [
        { label: translGlobal.title_overview, value: 'summary' },
        { label: translGlobal.title_howToFix, value: 'recommendation' },
        { label: translGlobal.title_httpInfo, value: 'request' },
        { label: translGlobal.title_details, value: 'events' },
        { label: translGlobal.title_notes_extraInfo, value: 'notes' },
        { label: translGlobal.title_activity, value: 'discussion' }
      ],
      model: {
        active: 'summary',
        appId: '',
        trace: undefined,
        bugtrackersCount: 0,
        showHttpRequestTab: true,
        showDetailsTab: true,
        discussionCount: {
          total: 0,
          unread: false,
          totalActivity: 0
        },
        status: VULN_STATUS
      },
      loadTracePromise: false,
      sendEmailModalOpen: false
    })

    angular.extend($scope, {
      tagTrace: tagTrace,
      deleteTag: deleteTag,
      sendBugtracker: sendToBugtracker,
      deleteTrace: deleteTrace,
      changeTab: changeTab,
      checkAppRole: checkAppRole,
      markAllMessagesAsRead: markAllMessagesAsRead,
      getTrace: getTrace,
      sendVulnerabilitiesEmail: sendVulnerabilitiesEmail,
      openEmailModal: openEmailModal,
      closeModal: closeModal,
      getBackUrl,
      checkRestrictedEditRole: checkRestrictedEditRole
    })

    function checkRestrictedEditRole() {
      const restrictedEditRole =
        UserService.getCurrentOrganization().properties.restricted_edit_role
      const roleToEvaluate = restrictedEditRole ? 'RULES_ADMIN' : 'EDIT'
      return checkAppRole(roleToEvaluate)
    }

    function getBackUrl() {
      return HistoryService.getBackUrl('vulns')
    }

    function init() {
      $scope.loadTracePromise = false

      if (!_deregisterCurrentTraceOnChange) {
        _deregisterCurrentTraceOnChange = currentTraceService.onChange(
          function (trace) {
            $scope.model.trace = trace
          }
        )
      }

      $scope.$on('$destroy', _destroy)

      VulnerabilitiesService.getOrgVulnVisibility(traceUuid).then(function (
        visible
      ) {
        if (visible) {
          $q.all([getTrace(), loadTags()]).then(function () {
            $scope.loadTracePromise = true

            var appId = $scope.model.trace.application.app_id
            if (
              UserService.isEnterprise() &&
              permissions.hasAppPermission(appId, 'EDIT')
            ) {
              getBugtrackers()
            }

            getUnreadTraceNotes()
            getApplicationDetails()
            getAppServers()
            getAppAttacks()
            getHttpRequest()
          })
        } else {
          $location.path(
            UserService.buildUrl('/vulns/' + traceUuid + '/unauthorized'),
            true
          )
        }
      })
    }

    function _destroy() {
      if (angular.isFunction(_deregisterCurrentTraceOnChange)) {
        _deregisterCurrentTraceOnChange()
      }
    }

    function loadTags() {
      return TagFactory.getTraceTagsByTrace(traceUuid).then(
        function (response) {
          $scope.tracetags = response.data.tags
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function getHttpRequest() {
      return appTracesApiConfig.getHttpRequest(traceUuid).then(
        function (response) {
          traceCommonRenderService.getHttpRequest($scope, response.data)
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function getBugtrackers() {
      return BugtrackerFactory.getBugtrackersByAppId(
        $scope.model.trace.application.app_id
      ).then(
        function (response) {
          $scope.model.bugtrackersCount = response.data.bugtrackers.length
          $scope.model.bugtrackers = response.data.bugtrackers
          return response.data.bugtrackers
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function getUnreadTraceNotes() {
      appTracesApiConfig
        .getUnreadTraceNotes($scope.model.trace.application.app_id, traceUuid)
        .then(
          function (response) {
            var data = response.data
            $scope.model.discussionCount.unread = data.unread
          },
          function (response) {
            ErrorService.processError(response)
          }
        )
    }

    function getApplicationDetails() {
      ApplicationFactory.getApplication(
        $scope.model.trace.application.app_id,
        'trace_breakdown,scores'
      ).then(
        function (response) {
          $scope.model.app = response.data.application

          $scope.model.app.importanceName = APP_IMPORTANCE_RANKING.find(
            function (item) {
              return item.value == $scope.model.app.importance
            }
          ).name
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function getAppServers() {
      ApplicationFactory.getServers(
        $scope.model.trace.application.app_id,
        '',
        true,
        false
      ).then(
        function (response) {
          $scope.model.appServers = response.data.servers
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function getAppAttacks() {
      if (permissions.isRASPEnabled()) {
        ApplicationFactory.getApplicationAttacks(
          $scope.model.trace.application.app_id
        ).then(
          function (response) {
            $scope.model.appAttacks = response.data.attacks
          },
          function (response) {
            ErrorService.processError(response)
          }
        )
      }
    }

    function getTrace() {
      return currentTraceService
        .init({
          type: VULNERABILITY_TYPE.ORG,
          traceUuid: traceUuid,
          expand:
            'events,notes_count,request,application,server_environments,violations,bugtracker,' +
            traceUuid
        })
        .then(function (trace) {
          permissions.updateAppPermissions(
            trace.application.app_id,
            trace.application.roles
          )
          return trace
        })
        .then(_getTraceResolve)
    }

    function _getTraceResolve(trace) {
      $scope.model.trace = trace

      $scope.model.showDetailsTab = !angular.isUndefined(
        $scope.model.trace.events
      )
      if (!$scope.model.showDetailsTab) {
        removeFromRouteSelect('events')
      }

      $scope.model.discussionCount.totalActivity =
        $scope.model.trace.total_notes

      $scope.model.appId = $scope.model.trace.application.app_id

      $rootScope.$broadcast('traces:overview:load')
    }

    function tagTrace() {
      var transl = {
        title_tagVulnerability: $translate.instant('title_tagVulnerability')
      }
      var selectedTraces = [traceUuid]
      var modalInstance
      modalInstance = $uibModal.open({
        templateUrl: 'views/tags/modal_tag.html',
        controller: 'ModalTagTracesCtrl',
        size: 'full',
        resolve: {
          traces: function () {
            return selectedTraces
          },
          title: function () {
            return transl.title_tagVulnerability
          }
        }
      })

      modalInstance.result.then(function () {
        loadTags()
      })
    }

    function deleteTag(data) {
      TagFactory.deleteTraceTags(traceUuid, data).then(
        function (response) {
          $scope.tracetags = response.data.tags
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function openEmailModal() {
      $scope.sendEmailModalOpen = true
    }

    function closeModal() {
      $scope.sendEmailModalOpen = false
    }

    function sendVulnerabilitiesEmail(email) {
      var data = {
        traces: [traceUuid],
        email: email
      }

      var promise

      if ($routeParams.appId) {
        promise = appTracesApiConfig.shareViaEmail($routeParams.appId, data)
      } else if ($routeParams.serverId) {
        promise = serverVulnsApiConfig.shareViaEmail(
          $routeParams.serverId,
          data
        )
      } else {
        promise = orgTraceApiConfig.shareViaEmail(data)
      }

      return promise.then(
        function (response) {
          logger.logSuccess(response.data.messages[0])
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function sendToBugtracker() {
      return csSendVulnService
        .open({
          resolve: {
            lastSent: function () {
              return $scope.model.trace.reported_to_bug_tracker_time
            },
            traces: function () {
              return [traceUuid]
            },
            bugtrackers: function () {
              return $scope.model.bugtrackers
            },
            appId: function () {
              return $scope.model.appId
            }
          }
        })
        .result.then(getTrace)
    }

    function deleteTrace() {
      var transl = {
        title_pleaseConfirmAction: $translate.instant(
          'title_pleaseConfirmAction'
        ),
        action_delete: $translate.instant('action_delete'),
        action_cancel: $translate.instant('action_cancel'),
        detail_vulnerabilityOverview_deleteVulnConfirmation: $translate.instant(
          'detail_vulnerabilityOverview_deleteVulnConfirmation'
        ),
        detail_vulnerabilityOverview_deletingTraces: $translate.instant(
          'detail_vulnerabilityOverview_deletingTraces'
        )
      }
      dialogs
        .confirm(
          transl.title_pleaseConfirmAction,
          transl.detail_vulnerabilityOverview_deleteVulnConfirmation,
          {
            size: 'sm',
            yes: transl.action_delete,
            no: transl.action_cancel
          }
        )
        .result.then(function () {
          appTracesApiConfig
            .deleteTraces($scope.model.trace.application.app_id, {
              traces: [traceUuid]
            })
            .then(
              function (response) {
                var log = logger.logSuccess(response.data.messages[0])
                var jobId = response.data.job_id
                $interval(
                  function () {
                    checkMap(
                      jobId,
                      log,
                      transl.detail_vulnerabilityOverview_deletingTraces
                    )
                  },
                  1000,
                  1
                )
              },
              function (response) {
                ErrorService.processError(response)
              }
            )
        })
    }

    function checkMap(jobId, log, msg) {
      GlobalFactory.getProgressTaskMap(jobId).then(
        function (response) {
          var total = response.data.data.total
          var progress = response.data.data.progress
          var newLog
          if (progress === total) {
            logger.remove(log)
            logger.logSuccess(msg + '. ' + total + ' vulnerabilities removed')
            $location.path(UserService.buildUrl('/vulns'), true)
          } else {
            logger.remove(log)
            newLog = logger.logWarning(
              '<strong>' +
                msg +
                '</strong><br/>' +
                $translate.instant(
                  'plural_vulnerabilityOverview_removedVulnerabilities',
                  {
                    countAvailableVulnerabilities: progress,
                    countRemovedVulnerabilities: total
                  },
                  'messageformat'
                ),
              { allowHtml: true }
            )
            $interval(
              function () {
                checkMap(jobId, newLog, msg)
              },
              1000,
              1
            )
          }
        },
        function (response) {
          logger.remove(log)
          ErrorService.processError(response)
        }
      )
    }

    //UI Actions
    function markAllMessagesAsRead() {
      appTracesApiConfig
        .updateNotesRead($scope.model.trace.application.app_id, traceUuid)
        .then(
          function () {
            $scope.model.discussionCount.unread = false
          },
          function (response) {
            ErrorService.processError(response)
          }
        )
    }

    function changeTab(tab) {
      $location.path(
        UserService.buildUrl('/vulns/' + traceUuid + '/overview/' + tab),
        true
      )
    }

    function checkAppRole(role) {
      if (
        $scope.model.trace &&
        VulnerabilitiesService.hasAppAccess($scope.model.trace, role)
      ) {
        return true
      }
      return false
    }

    $scope.$on(VULN_DISCUSSION_EVENTS.ADD, function () {
      $scope.model.discussionCount.totalActivity++
    })
    $scope.$on(VULN_DISCUSSION_EVENTS.DELETE, function () {
      $scope.model.discussionCount.totalActivity--
    })
    $scope.$on(ORG_VULN_EVENTS.ORG_TRACE_ACTIVE, function (event, data) {
      $scope.model.active = data.active
    })
    $scope.$on(VULN_REQUEST_EVENTS.HIDE_TAB, function () {
      removeFromRouteSelect('request')
      $scope.model.showHttpRequestTab = false
    })
    $scope.$on(ORG_VULN_EVENTS.LOAD_TITLE, function () {
      getTrace()
    })

    function removeFromRouteSelect(tab) {
      var index = _.findIndex($scope.routes, function (route) {
        return route.value == tab
      })
      if (index > -1) {
        $scope.routes.splice(index, 1)
      }
    }

    $scope.exportTrace = function (type) {
      if (type == EXPORT_TYPES.CSV) {
        VulnerabilitiesService.exportToCSV([traceUuid])
      } else if (type == EXPORT_TYPES.XML) {
        VulnerabilitiesService.exportToXML([traceUuid])
      }
    }

    init()
  }
})()
